import { AlignLeftIcon, CalendarLineIcon, ClockFullIcon, IconWeight, PersonFilledIcon, PinLocationFullIcon, TextformatTextIcon, VideocameraFullIcon } from "@inno-ui/icons";
import { Skeleton, SkeletonVariants } from "@inno-ui/skeleton";

import { getMeetingProviderIcon } from "./sidebar.helpers";
import styles from "./sidebar.module.scss";

type Props = {
  isLoading?: boolean;
  title?: string;
  description?: string;
  duration?: number;
  location?: string;
  meetingProvider?: string;
  participants?: number;
  timezone?: string;
};

export function Sidebar({ isLoading, title, description, duration, location, meetingProvider, participants, timezone }: Props) {
  // loading skeleton
  if (isLoading) {
    return (
      <div className={styles.sidebar}>
        <div className={styles.sidebarItems}>
          <Skeleton height={50} variant={SkeletonVariants.Rectangular} count={5} />
        </div>
      </div>
    );
  }

  // content
  return (
    <div className={styles.sidebar}>
      {/* title */}
      <div className={styles.sidebarItems}>
        <div className={styles.item}>
          <TextformatTextIcon color="var(--grey-500)" weight={IconWeight.Bold} />
          <p>{title}</p>
        </div>
        {/* description */}
        {!!description && (
          <div className={styles.item}>
            <AlignLeftIcon color="var(--grey-500)" weight={IconWeight.Bold} />
            <p>{description}</p>
          </div>
        )}
        {/* duration */}
        <div className={styles.item}>
          <ClockFullIcon color="var(--grey-500)" weight={IconWeight.Bold} />
          <p>
            {duration}
            {" "}
            minutes
          </p>
        </div>
        {/* location */}
        {!!location && (
          <div className={styles.item}>
            <PinLocationFullIcon color="var(--grey-500)" weight={IconWeight.Bold} />
            <p>{location}</p>
          </div>
        )}
        {/* meeting provider */}
        <div className={styles.item}>
          <VideocameraFullIcon color="var(--grey-500)" weight={IconWeight.Bold} />
          <p className={styles.meetingProviderText}>{getMeetingProviderIcon(meetingProvider ?? "")}</p>
        </div>
        {/* participants */}
        <div className={styles.item}>
          <PersonFilledIcon color="var(--grey-500)" weight={IconWeight.Bold} />
          <p>
            {participants}
            {" "}
            {participants === 1 ? "participant" : "participants"}
          </p>
        </div>
        <div className={styles.item}>
          <CalendarLineIcon color="var(--grey-500)" weight={IconWeight.Bold} />
          <p>
            {timezone}
          </p>
        </div>
      </div>
    </div>
  );
}
